"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunningExperiments = exports.PagesAndExperiments = exports.ExperimentName = exports.PageToPathnameRegexMap = exports.PageName = void 0;
// Add pages as new experiments are added.
var PageName;
(function (PageName) {
    PageName["AboutUs"] = "AboutUs";
    PageName["All"] = "All";
    PageName["BuyPage"] = "BuyPage";
    PageName["Homepage"] = "Homepage";
    PageName["InternalDealerAd"] = "InternalDealerAd";
    PageName["InternalDealerLead"] = "InternalDealerLead";
    PageName["InternalUnfurledVdp"] = "InternalUnfurledVdp";
    PageName["NewsArticle"] = "NewsArticle";
    PageName["NewsLanding"] = "NewsLanding";
    PageName["SearchResultsPage"] = "SearchResultsPage";
    PageName["VehicleDetailsPage"] = "VehicleDetailsPage";
})(PageName = exports.PageName || (exports.PageName = {}));
exports.PageToPathnameRegexMap = {
    [PageName.AboutUs]: /(^|(\/_next\/data\/.*))\/about-us(.json)?$/i,
    [PageName.All]: /^.*$/,
    [PageName.BuyPage]: /(^|(\/_next\/data\/.*))\/buy\/(?!.*(listing|search|search\.json)).*$/i,
    [PageName.Homepage]: /(^|(\/_next\/data\/.*))\/((index|base|variant).json)?$/,
    [PageName.InternalDealerAd]: /(^|(\/_next\/data\/.*))\/internal\/dealer-ad\/.*$/i,
    [PageName.InternalDealerLead]: /(^|(\/_next\/data\/.*))\/internal\/lead\/.*$/i,
    [PageName.InternalUnfurledVdp]: /(^|(\/_next\/data\/.*))\/internal\/unfurled-ad\/.*$/i,
    [PageName.NewsArticle]: /(^|(\/_next\/data\/.*))\/(features|news|regulars|road-tests)\/.*\/.*\/(\d*)(.json)?$/i,
    [PageName.NewsLanding]: /(^|(\/_next\/data\/.*))\/(features|news|regulars|road-tests)(\/[^\/]*)?(.json)?$/i,
    [PageName.SearchResultsPage]: /(^|(\/_next\/data\/.*))\/buy\/search.*$/i,
    [PageName.VehicleDetailsPage]: /(^|(\/_next\/data\/.*))\/buy\/listing\/.*$/i,
};
var ExperimentName;
(function (ExperimentName) {
    ExperimentName["ClpViewInventoryCta"] = "ClpViewInventoryCta";
    ExperimentName["EditorialVdpButton"] = "EditorialVdpButton";
    ExperimentName["RequiredPostcode"] = "RequiredPostcode";
    ExperimentName["SrpResultSetSize"] = "SrpResultSetSize";
    ExperimentName["SrpV2"] = "SrpV2";
})(ExperimentName = exports.ExperimentName || (exports.ExperimentName = {}));
exports.PagesAndExperiments = {
    [PageName.All]: {
        isStatic: true,
        // List all non-static pages
        excludeRedirectForPages: [
            PageName.SearchResultsPage,
            PageName.NewsLanding,
            PageName.InternalDealerAd,
            PageName.InternalDealerLead,
        ],
        page: PageName.All,
    },
    [PageName.AboutUs]: {
        page: PageName.AboutUs,
        isStatic: true,
    },
    [PageName.BuyPage]: {
        page: PageName.BuyPage,
        isStatic: true,
        experiment: {
            id: 'EyjB8N5RQgGgjwQKQwUMNQ',
            inTestWeight: 0.5,
            isLive: true,
            name: ExperimentName.ClpViewInventoryCta,
        },
    },
    [PageName.SearchResultsPage]: {
        page: PageName.SearchResultsPage,
        isStatic: false,
        experiment: {
            id: 'Tjlgu6BvReWx9nREUxKewg',
            inTestWeight: 0.5,
            isLive: false,
            name: ExperimentName.SrpResultSetSize,
        },
    },
    [PageName.Homepage]: {
        page: PageName.Homepage,
        isStatic: true,
    },
    [PageName.NewsArticle]: {
        page: PageName.NewsArticle,
        isStatic: true,
        experiment: {
            id: '9NogmGWyRlyukNoANjWpOQ',
            inTestWeight: 0.5,
            isLive: false,
            name: ExperimentName.EditorialVdpButton,
        },
    },
    [PageName.InternalUnfurledVdp]: {
        page: PageName.VehicleDetailsPage,
        isStatic: true,
    },
    [PageName.VehicleDetailsPage]: {
        page: PageName.VehicleDetailsPage,
        isStatic: true,
    },
};
exports.RunningExperiments = Object.values(exports.PagesAndExperiments)
    .filter((page) => !!(page === null || page === void 0 ? void 0 : page.experiment))
    .map((page) => page === null || page === void 0 ? void 0 : page.experiment);
//# sourceMappingURL=pages-and-experiments.js.map